import { isDefined } from '@app/utils/is';
import { IconComponent } from '@typings';
import React from 'react';

import { Box } from '../Icons';

interface Props {
  icon?: IconComponent;
  title: string;
  subtitle?: string;
  dataTestId?: string;
}

export const EmptyState = ({ dataTestId, icon: Icon = Box, title, subtitle, children }: React.WithOptionalChildren<Props>) => {
  return (
    <div
      data-testid={dataTestId}
      className="mx-auto mt-16 w-full rounded-regular bg-white p-10 px-6 text-center sm:w-min sm:min-w-96 sm:px-10"
    >
      <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-neutral-98">
        <Icon className="h-8 w-8 text-neutral-40" />
      </div>
      <h2 className="break-words heading-3">{title}</h2>
      {isDefined(subtitle) && <p className="mt-2 text-neutral-60 body-4">{subtitle}</p>}
      {isDefined(children) && <div className="mt-8 flex flex-col items-center justify-center gap-x-3 gap-y-2 sm:flex-row">{children}</div>}
    </div>
  );
};
